var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTakeCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 15 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.9,0.1c-0.2-0.2-0.5-0.2-0.7,0L9,5.3V3.5C9,3.2,8.8,3,8.5,3S8,3.2,8,3.5v3c0,0.1,0,0.1,0,0.2 c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.2,0h3C11.8,7,12,6.8,12,6.5S11.8,6,11.5,6 H9.7l5.1-5.1C15,0.7,15,0.3,14.9,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,11c-1.5,0-2.8-0.3-4.1-0.9C9.3,10,9.1,10,9,10c-0.1,0-0.2,0.1-0.3,0.3l-1.1,2.2c-2.2-1.2-4-3-5.2-5.2 l2.2-1.1C4.8,6.2,4.9,6.1,5,6c0-0.1,0-0.3,0-0.4C4.3,4.3,4,3,4,1.5C4,1.2,3.8,1,3.5,1h-3C0.2,1,0,1.2,0,1.5C0,8.9,6.1,15,13.5,15 c0.3,0,0.5-0.2,0.5-0.5v-3C14,11.2,13.8,11,13.5,11z M1,2h2c0.1,1.3,0.3,2.5,0.8,3.6L2,6.5C1.4,5.1,1.1,3.6,1,2z M13,14 c-1.6-0.1-3.1-0.4-4.5-1l0.9-1.8c1.1,0.5,2.3,0.8,3.6,0.8V14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeCall);
export default __webpack_public_path__ + "static/media/take-call.12d192cf3c5f5e121a3ade512fb69e28.svg";
export { ForwardRef as ReactComponent };